/** @jsx jsx */
import React, { type ComponentType, type ReactNode, type ReactElement } from 'react';
import { jsx } from '@compiled/react';
import noop from 'lodash/noop';
import { SpotlightManager } from '@atlaskit/onboarding';
import type { EmptyViewProps, ErrorViewProps } from '../../model/index.tsx';
import type { Status } from './common/selectors.tsx';

type Props = {
	isOnboardingEnabled: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Header: ComponentType<Record<any, any>> | undefined;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Table: ComponentType<Record<any, any>>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Paginator: ComponentType<Record<any, any>>;
	Empty: ComponentType<EmptyViewProps>;
	Error: ComponentType<ErrorViewProps>;
	status: Status;
	renderOnboardingSpotlight: (availableSpotlightTargets: string[]) => ReactElement;
	availableSpotlightTargets: string[];
	onAdd: () => void;
	onRetry: () => void;
};

export default function Content(props: Props): JSX.Element {
	const {
		Header,
		Table,
		Paginator,
		Empty,
		Error,
		status,
		onAdd,
		onRetry,
		isOnboardingEnabled,
		renderOnboardingSpotlight,
		availableSpotlightTargets,
	} = props;

	let main: ReactNode = null;
	let spotlight: ReactNode = null;

	switch (status) {
		case 'has-entities': {
			main = (
				<>
					<Table />
					<Paginator />
				</>
			);
			spotlight =
				isOnboardingEnabled &&
				renderOnboardingSpotlight &&
				renderOnboardingSpotlight(availableSpotlightTargets);
			break;
		}
		case 'empty': {
			main = Empty ? <Empty onAdd={onAdd} /> : null;
			break;
		}
		case 'error': {
			main = Error ? <Error onRetry={onRetry} /> : null;
			break;
		}

		default: {
			break;
		}
	}

	return (
		<SpotlightManager>
			<>
				{spotlight}
				{Header ? <Header /> : null}
				{main}
			</>
		</SpotlightManager>
	);
}

Content.defaultProps = {
	isOnboardingEnabled: false,
	renderOnboardingSpotlight: () => null,
	availableSpotlightTargets: [],
	onAdd: noop,
	onRetry: noop,
};
